import { Component, Input } from '@angular/core';

@Component({
  selector: 'bottom-sheet-title',
  standalone: true,
  imports: [],
  templateUrl: './bottom-sheet-title.component.html',
  styleUrl: './bottom-sheet-title.component.scss',
})
export class BottomSheetTitleComponent {
  @Input() title: string = '';
}
